import Interactive from 'assets/customSVG/sequence/actions/Interactive';
import Message from 'assets/customSVG/sequence/actions/Message';
import Media from 'assets/customSVG/sequence/actions/Media';
import List from 'assets/customSVG/sequence/actions/List';
import Template from 'assets/customSVG/sequence/actions/Template';
import Close from 'assets/customSVG/sequence/actions/Close';
import Key from 'assets/customSVG/sequence/actions/Key';
import Map from 'assets/customSVG/Map';
import Assignee from 'assets/customSVG/sequence/actions/Assignee';
import Nudge from 'assets/customSVG/sequence/actions/Nudge';
import CtaUrl from 'assets/customSVG/sequence/actions/CtaUrl';
import Person from 'assets/customSVG/Person';
import Flow from 'assets/customSVG/sequence/Flow';
import DollarIcon from 'assets/customSVG/DollarIcon';

export const ACTIONS_LIST = [
  {
    id: 1,
    label: 'Text Message',
    key: 'TEXT',
    icon: Message,
    disabled: false,
    bg: '#0ACD95',
    color: 'white',
    headerText: 'Send Message',
    headerBgColor: '#04B8A2',
    canAdd: true,
  },
  {
    id: 2,
    label: 'Media Message',
    key: 'MEDIA',
    icon: Media,
    disabled: false,
    bg: '#0ACD95',
    color: 'white',
    headerText: 'Send Message',
    headerBgColor: '#04B8A2',
    canAdd: true,
  },
  {
    id: 3,
    label: 'Interactive Message',
    key: 'BUTTON',
    icon: Interactive,
    disabled: false,
    bg: '#0ACD95',
    color: 'white',
    headerText: 'Send Message',
    headerBgColor: '#04B8A2',
    canAdd: true,
  },
  {
    id: 4,
    label: 'List Message',
    key: 'LIST',
    icon: List,
    disabled: false,
    bg: '#0ACD95',
    color: 'white',
    headerText: 'Send Message',
    headerBgColor: '#04B8A2',
    canAdd: true,
  },
  {
    id: 5,
    label: 'Location Request Message',
    key: 'LOCATION_REQUEST_MESSAGE',
    icon: Map,
    disabled: false,
    bg: '#0ACD95',
    color: 'white',
    headerText: 'Send Message',
    headerBgColor: '#04B8A2',
    canAdd: true,
  },
  {
    id: 6,
    label: 'Template Message',
    key: 'TEMPLATE',
    icon: Template,
    disabled: false,
    bg: '#0ACD95',
    color: 'white',
    headerText: 'Send Message',
    headerBgColor: '#04B8A2',
    canAdd: true,
  },
  {
    id: 7,
    label: 'Flow Message',
    key: 'FLOW',
    icon: Flow,
    disabled: false,
    bg: '#0ACD95',
    color: 'white',
    headerText: 'Send Message',
    headerBgColor: '#04B8A2',
    canAdd: true,
  },
  {
    id: 8,
    label: 'CTA URL Message',
    key: 'CTA_URL',
    icon: CtaUrl,
    disabled: false,
    bg: '#0ACD95',
    color: 'white',
    headerText: 'Send Message',
    headerBgColor: '#04B8A2',
    canAdd: true,
  },
  {
    id: 9,
    label: 'Contacts Message',
    key: 'CONTACTS',
    icon: Person,
    disabled: false,
    bg: '#0ACD95',
    color: 'white',
    headerText: 'Send Message',
    headerBgColor: '#04B8A2',
    canAdd: true,
  },
];

export const NODE_TYPES_CONVERSION = {
  TEXT: 'Text Message',
  MEDIA: 'Media Message',
  BUTTON: 'Interactive Message',
  LIST: 'List Message',
  LOCATION_REQUEST_MESSAGE: 'Location Request Message',
  TEMPLATE: 'Template Message',
  FLOW: 'Flow Message',
  CTA_URL: 'CTA URL Message',
  CONTACTS: 'Contacts Message',
  PAYMENT_CAPTURED: 'Text Message',
  PAYMENT_FAILED: 'Text Message',
};

export const OPERATIONS_LIST = [
  {
    id: 1,
    label: 'Add Nudge',
    key: 'NUDGE',
    icon: Nudge,
    disabled: true,
    bg: '#FBBF24',
    color: 'white',
    headerText: 'Add Nudge',
    headerBgColor: '#FBBF24',
  },
  {
    id: 2,
    label: 'Add Time Delay',
    key: 'FOLLOW_UP',
    icon: Nudge,
    disabled: false,
    canAdd: true,
    bg: '#3B82F6',
    color: 'white',
    headerText: 'Time Delay',
    headerBgColor: '#3B82F6',
  },
  {
    id: 3,
    label: 'Set Assignee',
    key: 'ASSIGNEE',
    icon: Assignee,
    disabled: false,
    canAdd: true,
    bg: '#6940F2',
    color: 'white',
    headerText: 'Set Assignee',
    headerBgColor: '#6940F2',
  },
  {
    id: 4,
    label: 'Keyword',
    key: 'KEYWORD',
    icon: Key,
    disabled: true,
    bg: '#F43F5E',
    color: 'white',
    headerText: 'Keyword',
    headerBgColor: '#F43F5E',
  },
  {
    id: 5,
    label: 'Close Conversation',
    key: 'CLOSE_CONVERSATION',
    icon: Close,
    disabled: true,
    bg: '#F97E5E',
    color: 'white',
    headerText: 'Close Conversation',
    headerBgColor: '#F97E5E',
  },
  {
    id: 6,
    label: 'Payment Captured',
    key: 'PAYMENT_CAPTURED',
    icon: DollarIcon,
    disabled: false,
    canAdd: true,
    bg: '#0ACD95',
    color: '#0ACD95',
    headerText: 'Payment Captured',
    headerBgColor: '#0ACD95',
  },
  {
    id: 7,
    label: 'Payment Failed',
    key: 'PAYMENT_FAILED',
    icon: DollarIcon,
    disabled: false,
    canAdd: true,
    bg: '#F97E5E',
    color: '#F97E5E',
    headerText: 'Payment Failed',
    headerBgColor: '#F97E5E',
  },
  {
    id: 8,
    label: 'Flow Completed',
    key: 'FLOW_COMPLETED',
    icon: Flow,
    disabled: false,
    canAdd: true,
    bg: '#0ACD95',
    color: 'white',
    headerText: 'Flow Completed',
    headerBgColor: '#0ACD95',
  }
];

const listData = [
  {
    rows: [
      {
        title: '',
        description: '',
      },
    ],
    title: '',
  },
];

export const INITIAL_NODE_TRIGGER_DATA = {
  TEXT: {
    type: 'text',
    text: {
      body: '',
    },
  },
  PAYMENT_CAPTURED: {
    type: 'text',
    text: {
      body: '',
    }
  },
  PAYMENT_FAILED: {
    type: 'text',
    text: {
      body: '',
    }
  },
  FLOW_COMPLETED: {
    type: 'text',
    text: {
      body: '',
    }
  },
  MEDIA: {
    type: 'image',
    image: {
      link: '',
    },
  },
  BUTTON: {
    type: 'interactive',
    interactive: {
      type: 'button',
      action: {
        buttons: [
          {
            type: 'reply',
            reply: {
              title: '',
            },
          },
        ],
      },
    },
  },
  LIST: {
    type: 'interactive',
    interactive: {
      type: 'list',
      body: {
        text: '',
      },
      action: {
        button: 'List',
        sections: listData,
      },
    },
  },
  TEMPLATE: {
    type: 'template',
    template: [],
    template_name: '',
    template_id: '',
    broadcast_name: '',
  },
  LOCATION_REQUEST_MESSAGE: {
    type: 'interactive',
    interactive: {
      type: 'location_request_message',
      body: {
        text: '',
      },
      action: {
        name: 'send_location',
      },
    },
  },
  CTA_URL: {
    type: 'interactive',
    interactive: {
      type: 'cta_url',
      body: {
        text: '',
      },
      action: {
        name: 'cta_url',
        parameters: {
          display_text: 'Click here',
          url: ''
        }
      },
    },
  },
  FLOW: {
    type: 'interactive',
    interactive: {
      type: 'flow',
      body: {
        text: '',
      },
      action: {
        name: 'flow',
        parameters: {
          flow_message_version: '3',
          flow_cta: 'View Flow',
          flow_name: '',
          flow_id: '',
          flow_identifier: '',
        },
      },
    },
  },
  CONTACTS: {
    type: 'contacts',
    contacts: [
      {
        name: {
          formatted_name: '',
          first_name: '',
          last_name: '',
          middle_name: '',
          suffix: '',
          prefix: ''
        },
        phones: [
          {
            phone: '',
            type: 'WORK',
            wa_id: ''
          }
        ],
        emails: [
          {
            email: '',
            type: 'WORK'
          }
        ],
        addresses: [
          {
            street: '',
            city: '',
            state: '',
            zip: '',
            country: '',
            country_code: '',
            type: 'WORK'
          }
        ],
        org: {
          company: '',
          department: '',
          title: ''
        },
        urls: [
          {
            url: '',
            type: 'WORK'
          }
        ],
        birthday: ''
      }
    ]
  },
};
